// src/actions/outlook-calendar.js

import api from './outlook-api'
import moment from 'moment'
import config from '../config'
import { emitAlertMessage, clearAlertMessage } from './alert-message'

export const FETCH_OUTLOOK_CALENDARS = "FETCH_OUTLOOK_CALENDARS"
export const FETCH_OUTLOOK_CALENDARS_REQUESTED = "FETCH_OUTLOOK_CALENDARS_REQUESTED"
export const FETCH_OUTLOOK_CALENDARS_COMPLETED = "FETCH_OUTLOOK_CALENDARS_COMPLETED"
export const FETCH_OUTLOOK_CALENDARS_FAILED = "FETCH_OUTLOOK_CALENDARS_FAILED"

export function fetchOutlookCalendarsRequested() {
  return {
    type: FETCH_OUTLOOK_CALENDARS_REQUESTED
  }
}

export function fetchOutlookCalendars() {
  return function(dispatch) {
    dispatch(fetchOutlookCalendarsRequested())
    return api.get(`/calendars`)
        .then((results)=> {
          dispatch(fetchOutlookCalendarsCompleted(results))
        })
        .catch((error)=> {
          Promise.all([
            dispatch(fetchOutlookCalendarsFailed(error)),
            dispatch(emitAlertMessage(error, 'error'))
          ])
        })
  }
}

export function fetchOutlookCalendarsCompleted(results) {
  return {
    type: FETCH_OUTLOOK_CALENDARS_COMPLETED,
    results,
  }
}

export function fetchOutlookCalendarsFailed(error) {
  return {
    type: FETCH_OUTLOOK_CALENDARS_FAILED,
    error,
  }
}

export const CLEAR_OUTLOOK_CALENDARS = "CLEAR_OUTLOOK_CALENDARS"

export function clearOutlookCalendars() {
  return {
    type: CLEAR_OUTLOOK_CALENDARS
  }
}

export const FETCH_OUTLOOK_CALENDAR_EVENTS = "FETCH_OUTLOOK_CALENDAR_EVENTS"
export const FETCH_OUTLOOK_CALENDAR_EVENTS_REQUESTED = "FETCH_OUTLOOK_CALENDAR_EVENTS_REQUESTED"
export const FETCH_OUTLOOK_CALENDAR_EVENTS_COMPLETED = "FETCH_OUTLOOK_CALENDAR_EVENTS_COMPLETED"
export const FETCH_OUTLOOK_CALENDAR_EVENTS_FAILED = "FETCH_OUTLOOK_CALENDAR_EVENTS_FAILED"

export function fetchOutlookCalendarEventsRequested(selectDate) {
  return {
    type: FETCH_OUTLOOK_CALENDAR_EVENTS_REQUESTED,
    selectDate
  }
}

export function fetchOutlookCalendarEvents(selectDate, calendar) {
  const startDateTime = moment(selectDate).startOf('day').toISOString()
  const endDateTime = moment(selectDate).endOf('day').toISOString()
  return function(dispatch) {
    dispatch(fetchOutlookCalendarEventsRequested(selectDate))
    const query = calendar != 'primary' && `/calendars/${calendar}/calendarview` || '/calendarview'
    return api.get(`${query}`, { startDateTime, endDateTime })
        .then((results)=> {
          dispatch(fetchOutlookCalendarEventsCompleted(selectDate, calendar, results.map((item)=> {
            // isOneDay: １日に収まる予定を判定
            const isOneDay =  moment(item.start.startTime).format('YYYY-MM-DD') == moment(item.end.endTime).format('YYYY-MM-DD')
            const title = !item.subject ? '件名なし' : item.subject
            return {
              event_id: item.id,
              title,
              date: item.start.dateTime.slice(0, 10),
              endDate: isOneDay && !item.isAllDay ? null : item.end.dateTime, // 終日とそれ以外の予定を判定
              startTime: item.isAllDay ? null : item.start.dateTime,
              endTime: item.isAllDay ? null : item.end.dateTime,
              description: item.body.content
            }
          })))
        })
        .catch((error)=> {
          Promise.all([
            dispatch(fetchOutlookCalendarEventsFailed(error)),
            dispatch(emitAlertMessage(error, 'error'))
          ])
        })
  }
}
export function fetchOutlookCalendarEventsCompleted(selectDate, calendar,results) {
  return {
    type: FETCH_OUTLOOK_CALENDAR_EVENTS_COMPLETED,
    selectDate, calendar, results
  }
}

export function fetchOutlookCalendarEventsFailed(error) {
  return {
    type: FETCH_OUTLOOK_CALENDAR_EVENTS_FAILED,
    error,
  }
}

export const CLEAR_OUTLOOK_CALENDAR_EVENTS = "CLEAR_OUTLOOK_CALENDARS_EVENTS"

export function clearOutlookCalendarEvents() {
  return {
    type: CLEAR_OUTLOOK_CALENDAR_EVENTS
  }
}


// WEBPACK FOOTER //
// ./src/actions/outlook-calendar.js